// extracted by mini-css-extract-plugin
export default {"open":"TeamActions__open--SttYMS5rnERZD74plRsJ","close":"TeamActions__close--R1D0fm16bvyXB6XV3vGJ","voiceIcon":"TeamActions__voiceIcon--Ifx3OoVPN6819FLbJsVs"};